import { computed, getCurrentInstance, reactive, ref } from '@vue/composition-api';

export const useGroupSelector = () => {
  const vm = getCurrentInstance();
  const store =  vm.proxy.$store;
  const router = vm.proxy.$router;

  const currentTab = computed(() => store.getters['groupSelector/currentTab'] || 'parentGroup');
  const group = computed(() => store.getters['groupSelector/group'] || null);
  const groups = computed(() => store.getters['groupSelector/groups'] || []);
  const groupsForDropdown = computed(() => {
    return groups.value.map((g) => {
      return { value: g.groupCk, text: g.groupName }
    });
  });
  const hasSelectedAll = computed(() => store.getters['groupSelector/hasSelectedAll']);
  const hasSelectedGroup = computed(() => store.getters['groupSelector/hasSelectedGroup']);
  const hasSelectedParentGroup = computed(() => store.getters['groupSelector/hasSelectedParentGroup']);
  const hasSelectedSubgroup = computed(() => store.getters['groupSelector/hasSelectedSubgroup']);
  const hasSelection = computed(() => store.getters['groupSelector/hasSelection'] || false);
  const loginSubGroups = computed(() => store.getters['groupSelector/loginSubGroups']);
  const parentGroup = computed(() => store.getters['groupSelector/parentGroup'] || null);
  const parentGroups = computed(() => store.getters['groupSelector/parentGroups'] || []);
  const searchId = computed(() => store.getters['groupSelector/searchId']);
  const searchName = computed(() => store.getters['groupSelector/searchName']);
  const searching = computed(() => store.getters['groupSelector/searching']);
  const selected = computed(() => store.getters['groupSelector/selected']);
  const showSearch = computed(() => store.getters['groupSelector/showSearch']);
  const subGroup = computed(() => store.getters['groupSelector/subGroup']);
  const subGroups = computed(() => store.getters['groupSelector/subGroups']);
  const subGroupsForDropdown = computed(() => {
    // console.log(`subs for dd`, this);
    return store.getters['groupSelector/subGroups'].map((sg) => {
      return { value: sg.subGroupCk, text: sg.subGroupName };
    });
  });
  const tabs = computed(() => store.getters['groupSelector/tabs']);
  const tabsVisible = computed(() => store.getters['groupSelector/tabsVisible']);
  const userHasOneParent = computed(() => store.getters['groupSelector/userHasOneParent']);
  const isBillingOverviewPage = computed(() => vm.proxy.$route.name === 'billing-overview');

  /**
   * 
   * @param { string } tab - a tab to switch to.  If omitted, current tab remains unchanged.
   */
  const openGroupSelector = (tab = 'parentGroup') => {
    console.log(`openGroupSelector`, tab);
    if(parentGroups.value.length === 1) {
      tab = 'group';
      if(groups.value.length === 1) {
        tab = 'subGroup';
      }
    }
    store.commit('groupSelector/SET_CURRENT_TAB', tab);
    store.commit('groupSelector/SET_SHOW_SEARCH', true);
  }

  /**
   * 
   * @param {string} groupCk 
   * @returns the first group matching the provided groupCk
   */
  const findFirstGroupByCk = (groupCk) => {
    return groups.value.find(g => g.groupCk === groupCk);
  }

  /**
   * 
   * @param {string} subGroupCk 
   * @returns first subGroup matching the subGroupCk
   */
  const findFirstSubGroupByCk = (subGroupCk) => {
    return store.getters['groupSelector/subGroups'].find(sg => sg.subGroupCk === subGroupCk);
  }

  const goToGroup = (group) => {
    router.push({
      name: 'group',
      params: {
        groupId: group.groupId,
      }
    })
  }

  const goToSubGroup = (subGroup) => {
    router.push({
      name: 'subgroup',
      params: {
        groupCk: subGroup.groupCk,
        subGroupCk: subGroup.subGroupCk
      }
    });
  }

  const updateFilter = (filter) => {
    store.commit('groupSelector/SET_SEARCH_ID', filter.id);
    store.commit('groupSelector/SET_SEARCH_NAME', filter.name);
  }

  return {
    currentTab,
    findFirstGroupByCk,
    findFirstSubGroupByCk,
    goToGroup,
    goToSubGroup,
    group,
    groups,
    groupsForDropdown,
    hasSelectedAll,
    hasSelectedGroup,
    hasSelectedParentGroup,
    hasSelectedSubgroup,
    hasSelection,
    loginSubGroups,
    openGroupSelector,
    parentGroup,
    parentGroups,
    searchId,
    searchName,
    searching,
    selected,
    showSearch,
    subGroup,
    subGroups,
    subGroupsForDropdown,
    tabs,
    tabsVisible,
    updateFilter,
    userHasOneParent,
    isBillingOverviewPage
  }
}
